import { Avatar, Icons } from '@commenda/kakashi';

interface AccountManagerCardProps {
  name: string;
  title: string;
  email: string;
  image?: string;
  meetingCalendarLink?: string;
}

export const AccountManagerCard = ({
  name,
  title,
  email,
  image,
  meetingCalendarLink,
}: AccountManagerCardProps) => (
  <div className="flex w-80 flex-col gap-lg rounded-md border border-border-primary bg-bg-primary p-lg shadow-[0px_2px_8px_0px_rgba(0,0,0,0.08)]">
    <div className="flex items-center gap-md">
      <Avatar
        size="md"
        name={name}
        image={image}
        className="shrink-0"
        colorSeed={name}
      />
      <div className="flex min-w-0 flex-col gap-xxs">
        <span className="txt-small-medium truncate text-text-primary">
          {name}
        </span>
        <span className="txt-extra-small-regular truncate text-text-secondary">
          {title}
        </span>
      </div>
    </div>

    <div className="h-px w-full bg-border-secondary" />

    <div className="flex flex-col gap-sm">
      {meetingCalendarLink && (
        <a
          href={meetingCalendarLink}
          target="_blank"
          rel="noreferrer"
          className="flex h-7 w-fit items-center gap-sm pl-xs pr-sm transition-colors"
        >
          <Icons.Calendar className="size-3 text-fg-secondary" />
          <span className="txt-extra-small-medium text-text-primary">
            Schedule a call
          </span>
        </a>
      )}

      <a
        href={`mailto:${email}`}
        className="flex h-7 w-fit items-center gap-sm pl-xs pr-sm transition-colors"
      >
        <Icons.Mail01 className="size-3 text-fg-secondary" />
        <span className="txt-extra-small-medium text-text-primary">
          {email}
        </span>
      </a>
    </div>
  </div>
);
